import type { OperationAvailability } from '../operations';
import { toolError, type TemplateWebMCPFailure } from '../responses';
import type { TemplateToolContext } from '../toolContext';

export const ANIMATION_UNAVAILABLE_MESSAGE =
  'Animation is not available. It needs cm-template-webmcp and cm-template-builder-animations on a Figma template.';

export function animationAvailability(
  context: Pick<TemplateToolContext, 'animationsEnabled' | 'store'>,
): OperationAvailability {
  const state = context.store?.getState();
  const figma = state == null || state.importSourceType === 'figma';
  return { animationsEnabled: context.animationsEnabled === true && figma };
}

export function animationUnavailable(): TemplateWebMCPFailure {
  return toolError('CAPABILITY_UNAVAILABLE', ANIMATION_UNAVAILABLE_MESSAGE);
}
